export const VALIDATIONS_CASES = {
    required: {
        message: 'This field is required',
        validator: (value: string) => {
            return typeof value === 'string' && value.trim().length > 0;
        }
    },
    'phone-format': {
        message: 'Invalid phone number',
        validator: (value: string) => {
            const phoneRegex = /^\d{10}$/;
            return phoneRegex.test(value || '');
        }
    },
    'email-format': {
        message: 'Invalid email',
        validator: (value: string) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(value || '');
        }
    }
};
